import { dateTimeDisplay } from './user-invitations/userInvitationsHelpers'
import { deleteContact } from '../actions/companyUsers'
import { xhrRequest } from '../../../shared/helpers'

const CompanyContactsTable = ({ contacts, companyContactsUrl, dispatch }) => {

  const onClickDelete = (contact) => {
    if (confirm('Are you sure you want to remove this contact?')) {
      xhrRequest(`${companyContactsUrl}/${contact.id}`, 'DELETE', {}).then(res => {
        dispatch(deleteContact(contact))
        App.FlashAlerts.renderAlert("Contact was successfully deleted", "notice")
      }).catch(err => {
        console.log(err)
        App.FlashAlerts.renderAlert("Failed to delete a contact", "alert")
      })
    }
  }

  return (
    <div id="user-invitations-table-div">
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Company</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {contacts.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">No contacts found.</td>
            </tr>
          )}
          {contacts.map(contact => {
            return (
              <tr key={contact.id}>
                <td>{contact.first_name} {contact.last_name}</td>
                <td>{contact.email}</td>
                <td>{contact.title}</td>
                <td>{dateTimeDisplay(contact.created_at, true)}</td>
                <td>{contact.company_name}</td>
                <td>
                  <button className="btn btn-default btn-delete btn-sm" onClick={() => onClickDelete(contact)}>
                    Delete
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
const mapStateToProps = ({ contacts, companyContactsUrl }) => ({ contacts, companyContactsUrl })
export default connect(mapStateToProps)(CompanyContactsTable)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/CompanyContactsTable.js